import { useEffect, useState } from "react";

import { ModalComponent } from "../..";
import { formatDate, formatToCurrency } from "../../../../helperFunctions";
import {
  useMemberFetchLoanDetailsQuery,
  useOfficialFetchLoanDetailsQuery,
} from "../../../../redux/features/loans/loans.api";
import {
  FullLoanDetails,
  SingleLoan,
} from "../../../../redux/features/loans/loans.type";
import { TagCard } from "../../../cards/tagCard";
import { TableComponent } from "../../../table/table";

export const LoanRepaymentScheduleModal = ({
  isModalOpen,
  onModalClose,
  // cooperativeDetails,
  loanDetails,
  type,
}: {
  isModalOpen: boolean;
  onModalClose: () => void;
  // cooperativeDetails: SingleCooperativeDetails;
  loanDetails: SingleLoan;
  type: "member" | "official";
}) => {
  const [fullLoanDetails, setFullLoanDetails] = useState<FullLoanDetails>();

  const { data: memberFullLoanDetails, isFetching: memberFetchingLoanDetails } =
    useMemberFetchLoanDetailsQuery(
      {
        loan_id: loanDetails.id,
        detail: true,
        coop: loanDetails.Cooperative,
      },
      {
        skip: !isModalOpen || type !== "member",
        refetchOnMountOrArgChange: true,
      }
    );

  const {
    data: officialFullLoanDetails,
    isFetching: officialFetchingLoanDetails,
  } = useOfficialFetchLoanDetailsQuery(
    {
      loan_id: loanDetails.id,
      detail: true,
      coop: loanDetails.Cooperative,
    },
    {
      skip: !isModalOpen || type !== "official",
      refetchOnMountOrArgChange: true,
    }
  );

  useEffect(() => {
    if (type === "member") {
      setFullLoanDetails(memberFullLoanDetails?.data);
    } else {
      setFullLoanDetails(officialFullLoanDetails?.data);
    }
  }, [memberFullLoanDetails, officialFullLoanDetails, type]);

  return (
    <>
      <ModalComponent
        isModalOpen={isModalOpen}
        onModalClose={() => {
          onModalClose();
        }}
        title={`Repayment Schedule`}
        topTitle
        subTitle=""
        childrenClassName="flex flex-col gap-6"
        modalClassName="!min-h-[572px] !max-w-[1038px]"
        hasButtons={false}
      >
        <TableComponent
          className="w-full !min-w-max md:!min-w-full"
          isRowClickable={false}
          mobileCardView
          headers={[
            "Due Date",
            "Amount Paid",
            "Repayment Amount",
            "Principal",
            "Interest",
            "Penalty Fee",
            "Status",
          ]}
          headerClassName="!bg-white"
          isLoading={memberFetchingLoanDetails || officialFetchingLoanDetails}
          isTableEmpty={[0, undefined].includes(
            fullLoanDetails?.Repayment?.length
          )}
          isPaginated={false}
          emptrySrc="/assets/images/empty_state_cooperatives.svg"
          emptyTitle="No Schedule Found"
          totalCount={fullLoanDetails?.Repayment?.length}
          rows={
            fullLoanDetails?.Repayment?.map((item, idx) => {
              const key = `$loan-schedule-${idx}`;

              return {
                id: item?.id,
                items: [
                  formatDate(item.due_date),
                  formatToCurrency(item.amountPaid, {
                    decimalPlaces: 2,
                    currency: "NGN",
                  }),
                  formatToCurrency(item.amount_due, {
                    decimalPlaces: 2,
                    currency: "NGN",
                  }),
                  formatToCurrency(item.principal_due, {
                    decimalPlaces: 2,
                    currency: "NGN",
                  }),
                  formatToCurrency(item.interest_due, {
                    decimalPlaces: 2,
                    currency: "NGN",
                  }),
                  formatToCurrency(item.lateFee ?? 0, {
                    decimalPlaces: 2,
                    currency: "NGN",
                  }),
                  <TagCard
                    text={item.isPaid ? "Paid" : "Pending"}
                    type={item?.isPaid ? "success" : "pending"}
                    key={`${key}-status`}
                  />,
                ],
              };
            }) ?? []
          }
        />
      </ModalComponent>
    </>
  );
};
